import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL?.trim();
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY?.trim();

/** True when this build has Supabase URL + anon key (inlined at build time on Vercel). */
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

// Never throw at import time — missing env would blank-screen the SPA on Vercel.
// When misconfigured, App shows setup instructions and avoids mounting auth.
const placeholderUrl = 'https://placeholder.supabase.co';
const placeholderKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0';

export const supabase: SupabaseClient = createClient(
  isSupabaseConfigured ? supabaseUrl! : placeholderUrl,
  isSupabaseConfigured ? supabaseAnonKey! : placeholderKey
);

if (!isSupabaseConfigured && typeof window !== 'undefined') {
  console.warn(
    '[Worldasia] Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY at build time. Add them in Vercel → Settings → Environment Variables and redeploy.'
  );
}

export default supabase;
